const validatePlaylistUpdate = (dropdownlist, savedSites, currentSites) => {
  if (dropdownlist && savedSites?.isSuccess) {
    let matchingSitesCount = 0;
    const savedSiteIds = savedSites?.payload?.records?.map(
      (site) => `${site.siteId}---${site.siteName}`,
    );
    if (savedSiteIds?.length) {
      let count = 0;
      currentSites.forEach((siteId) => {
        if (savedSiteIds.includes(siteId)) {
          count += 1;
        }
      });
      matchingSitesCount = count;
    }

    if (matchingSitesCount > 0) {
      if (matchingSitesCount === 1 && currentSites?.length === 1) {
        return {
          isValid: true,
          dropdownMessage:
            'The site is already saved here. Please choose another list.',
        };
      }
      if (matchingSitesCount === currentSites.length) {
        return {
          isValid: true,
          dropdownMessage:
            'The sites are already saved here. Please choose another list.',
        };
      }
      return { isValid: false, matchingSitesCount };
    }
  }

  return { isValid: savedSites?.isLoading, dropdownMessage: '' };
};

const validatePlaylist = (
  selectedPlaylist,
  dropdownlist,
  regex,
  playlist,
  savedSites,
  currentSites,
) => {
  if (!regex.test(selectedPlaylist)) {
    return { isValid: true, message: 'Special characters are not allowed.' };
  }

  if (selectedPlaylist.length > 20) {
    return {
      isValid: true,
      message: 'A maximum of 20 characters are allowed.',
    };
  }

  if (
    selectedPlaylist?.trim().length >= 1 &&
    selectedPlaylist.trim().length < 3 &&
    dropdownlist.trim().length < 3
  ) {
    return {
      isValid: true,
      message: 'A minimum of 3 characters are required.',
    };
  }

  if (selectedPlaylist.trim().length < 3 && dropdownlist.trim().length < 3) {
    return { isValid: true, message: '' };
  }

  if (playlist.length > 0) {
    const isDuplicate = playlist.some(
      (item) =>
        item.Name.toLowerCase().trim() ===
        selectedPlaylist.toLowerCase().trim(),
    );
    if (isDuplicate) {
      return { isValid: true, message: 'list name already exists.' };
    }
  }

  if (dropdownlist) {
    return validatePlaylistUpdate(dropdownlist, savedSites, currentSites);
  }

  return { isValid: false, message: '' };
};

export default validatePlaylist;
